import React, { useState } from "react";
import "./QuestionareSteps.css";

const QuestionareSteps = ({ currentStep, setCurrentStep, stepsCompleted }) => {
  const [totalSteps] = useState(4);
  return (
    <div className="steps_container">
      {currentStep !== 1 && (
        <div className="previous_btn" onClick={() => setCurrentStep(currentStep > 1 ? currentStep - 1 : currentStep)}>
          <div className="back_arrow_btn"></div>
        </div>
      )}
      {/* <div className={"questionare_completed" + (currentStep === 1 ? " questionare_fullmarg" : "")}>
        {((currentStep - 1) / totalSteps) * 100}% Complete
      </div> */}
    </div>
  );
};

export default QuestionareSteps;
